import request from '@/utils/request'

export function list(params) {
  return request({
    url: '/norm_menus',
    method: 'get',
    params,
  })
}
